module.exports = __webpack_public_path__ + "img/arch_with_veil.eb53781d.jpg";